var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 29,
    viewBox: "0 0 101 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 100",
    x: 0.84082,
    y: 0.37085,
    width: 27.7819,
    height: 27.7819,
    fill: "#BDDFFF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 105",
    width: 18.7103,
    height: 5.1028,
    rx: 2.5514,
    transform: "matrix(1 0 0 -1 5.37646 24.184)",
    fill: "#5CA9F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 101",
    x: 36.5605,
    y: 0.37085,
    width: 27.7819,
    height: 27.7819,
    fill: "#BDDFFF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6631 8.30853C43.9017 8.30853 41.6631 10.5471 41.6631 13.3085V19.1839C41.6631 21.9453 43.9017 24.1839 46.6631 24.1839H54.8064C57.5678 24.1839 59.8064 21.9453 59.8064 19.1839V13.3085C59.8064 10.5471 57.5678 8.30853 54.8064 8.30853H46.6631ZM48.1989 12.2774C47.0943 12.2774 46.1989 13.1728 46.1989 14.2774V18.2151C46.1989 19.3196 47.0943 20.2151 48.1989 20.2151H53.2705C54.3751 20.2151 55.2705 19.3196 55.2705 18.2151V14.2774C55.2705 13.1728 54.3751 12.2774 53.2705 12.2774H48.1989Z",
    fill: "#5CA9F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 102",
    x: 72.2808,
    y: 0.370728,
    width: 27.7819,
    height: 27.7819,
    fill: "#BDDFFF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 103",
    x: 76.249,
    y: 20.479,
    width: 22.8242,
    height: 5.1028,
    rx: 2.5514,
    transform: "rotate(-45 76.249 20.479)",
    fill: "#5CA9F0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 104",
    width: 22.8242,
    height: 5.1028,
    rx: 2.5514,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 96.0938 20.4789)",
    fill: "#5CA9F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.90e7f0881799e0e189aef49757fa2a27.svg";
export { ForwardRef as ReactComponent };